import React, {useCallback, useContext, useEffect, useReducer, useRef, useState} from "react"
import {TemplateInstanceContext} from "../../Providers/TemplateInstanceProvider";


export default () => {
  return useContext(TemplateInstanceContext);
}